import { FC } from 'react';

import leapifyLogo from 'assets/images/Leapify-Logo.svg';
import { Formik, type FormikHelpers } from 'formik';
import {
  CHANGE_EXPIRED_PASSWORD_FORM,
  CHANGE_EXPIRED_PASSWORD_SCHEMA,
} from 'pages/public/forms/schema';
import PasswordExpiredForm from 'pages/public/forms/PasswordExpiredForm';
import { useChangeExpiredPassword } from 'pages/public/hooks';
import { LoginData } from 'pages/public/hooks/useLogin';

const FORM_INIT = { oldPassword: '', password: '', passwordConfirmation: '' };

const PasswordExpired: FC<Partial<LoginData>> = () => {
  const { mutate: changeExpiredPassword, error } = useChangeExpiredPassword();

  const handleSubmit = (
    value: CHANGE_EXPIRED_PASSWORD_FORM,
    { setSubmitting }: FormikHelpers<any>,
  ) => {
    setSubmitting(false);
    changeExpiredPassword(value);
  };

  console.log(error);

  return (
    <>
      <img
        alt="Leapify Logo"
        className="w-[170px] mb-[50px] mx-auto"
        src={leapifyLogo}
      />
      <Formik
        initialValues={FORM_INIT}
        onSubmit={handleSubmit}
        validationSchema={CHANGE_EXPIRED_PASSWORD_SCHEMA}
      >
        {() => <PasswordExpiredForm />}
      </Formik>
      <div className="text-secondary-light text-xs mt-2">
        v{import.meta.env.VITE_APP_VERSION}
      </div>
    </>
  );
};

export default PasswordExpired;
